import { Entry, IAddressCaptureContent, IGenericInputFactory } from '@belong/types';
import { SCREEN_CMS_FACTORY_MAP } from '../genericScreen.factory';
import { FGenericInput } from '../inputs';
import { FMoleculeAlert } from '../molecules';
import { parseFlexibleContent } from '../parseFlexibleContent';

export const FOrganismAddressCapture = (data: Entry<any>): IAddressCaptureContent => {
  // Data validation is handled in Contentful - this is just a transformation layer to convert to the correct types for the component
  const {
    showManualSearchLabel,
    hideManualSearchLabel,
    addressSummaryHeading,
    multipleResultsHeading,
    multipleResultsAlert,
    manualSearchHeading,
    a11yClearSearch,
    a11yClearProperty,
    a11yClearStreet,
    a11yNoResults,
    a11ySingleResult,
    a11yMultipleResults
  } = data.fields;

  const partialInput = FGenericInput<'required' | 'invalid'>(data.fields.addressInput);
  const manualInputs = parseFlexibleContent(data.fields.manualSearchInputs, SCREEN_CMS_FACTORY_MAP);

  return {
    search: {
      switchLabel: {
        collapsed: showManualSearchLabel,
        expanded: hideManualSearchLabel
      },
      partial: {
        heading: partialInput.label,
        description: partialInput.description,
        placeholder: partialInput.placeholder,
        errorMessage: partialInput.errorMessages,
        summaryHeading: addressSummaryHeading
      },
      manual: {
        heading: manualSearchHeading,
        propertyType: manualInputs.propertyType as IGenericInputFactory<'required'>,
        subAddressNumber: manualInputs.subAddressNumber as IGenericInputFactory<'required'>,
        streetNumber: manualInputs.streetNumber as IGenericInputFactory<'required'>,
        streetName: manualInputs.streetName as IGenericInputFactory<'required'>,
        streetType: manualInputs.streetType as IGenericInputFactory<'required'>,
        suburb: manualInputs.suburb as IGenericInputFactory<'required'>,
        state: manualInputs.state as IGenericInputFactory<'required'>,
        postcode: manualInputs.postcode as IGenericInputFactory<'required' | 'invalid'>
      },
      a11y: {
        clearSearchValueMessage: a11yClearSearch,
        clearPropertyValueMessage: a11yClearProperty,
        clearStreetValueMessage: a11yClearStreet,
        multipleResultsMessage: a11yMultipleResults,
        noResultsMessage: a11yNoResults,
        singleResultMessage: a11ySingleResult
      }
    },
    resolve: {
      heading: multipleResultsHeading,
      multipleResultsAlert: FMoleculeAlert(multipleResultsAlert)
    }
  };
};
